export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL;
export const UPLOAD_BASE_URL = process.env.REACT_APP_UPLOAD_BASE_URL;
